import { useEffect, useState } from 'react';
import { ILinkedCampaigns } from '../../../../../model/campaign/Campaign';
import { LongTermService } from '../service';
import { useParams } from 'react-router-dom';
import { IParams } from '../../../../../model/shared/IParams';
import { ErrorToast } from '../../../../../utils/toasters';
import { IContract } from '../../../../../model/shared/IContract';
import { ContractInfo } from '../dto/IDashContracts';
import { ICampaignManagement } from '../../dashboard/components/dto/ICampaignManagement';
import { CampaignService } from '../../service';
import { User } from '../../../../../model/user/User';

export function useLongTermDashboard() {
    const [campaigns, setCampaigns] = useState<ILinkedCampaigns[]>([]);
    const [contracts, setContracts] = useState<IContract[]>([]);
    const [contractsInfo, setContractsInfo] = useState<ContractInfo>();
    const [managementInfo, setManagementInfo] = useState<ICampaignManagement>();
    const [updateManagement, setUpdateManagement] = useState(false);
    const [supervisors, setSupervisors] = useState<User[]>([]);
    const [filterContracts, setFilterContracts] = useState({ page: 1, perPage: 7 });
    const [filterChildCampaigns, setFilterChildCampaigns] = useState({ page: 1, perPage: 7 });
    const [contractsCount, setContractsCount] = useState(0);
    const [campaignCount, setCampaignCount] = useState(0);

    const [isCampaignsLoading, setIsCampaignsLoading] = useState(true);
    const [isContractsLoading, setIsContractsLoading] = useState(true);
    const [isManagementLoading, setIsManagementLoading] = useState(true);
    const [isSupervisorsLoading, setIsSupervisorsLoading] = useState(true);

    const { id } = useParams<keyof IParams>();

    useEffect(() => {
        if (!id) {
            return;
        }

        let isCurrent = true;
        LongTermService.getLinkedCampaigns(id, filterChildCampaigns)
            .then(response => {
                if (!isCurrent) return;
                setCampaigns(response.data);
                setCampaignCount(response.count);
            })
            .catch(error => ErrorToast(error))
            .finally(() => {
                if (isCurrent) setIsCampaignsLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [id, filterChildCampaigns]);

    useEffect(() => {
        if (!id) {
            return;
        }

        let isCurrent = true;
        LongTermService.getContracts(id, filterContracts)
            .then(response => {
                if (!isCurrent) return;
                setContracts(response.data);
                setContractsCount(response?.count);
                setContractsInfo(response.info);
            })
            .catch(error => ErrorToast(error))
            .finally(() => {
                if (isCurrent) setIsContractsLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [id, filterContracts]);

    useEffect(() => {
        if (!id) {
            return;
        }
        LongTermService.getManagementData(id)
            .then(response => {
                setManagementInfo(response);
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsManagementLoading(false));
    }, [id, updateManagement]);

    useEffect(() => {
        if (!id) {
            return;
        }
        CampaignService.getSupervisors(+id)
            .then(data => {
                setSupervisors(data);
            })
            .catch(error => ErrorToast(error))
            .finally(() => setIsSupervisorsLoading(false));
    }, [id]);

    return {
        campaigns,
        contracts,
        contractsInfo,
        managementInfo,
        supervisors,
        setUpdateManagement,
        contractsCount,
        setFilterContracts,
        filterContracts,
        campaignCount,
        filterChildCampaigns,
        setFilterChildCampaigns,
        isCampaignsLoading,
        isContractsLoading,
        isManagementLoading,
        isSupervisorsLoading,
    };
}
